import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { DeliveryCard } from "components/Pdfs";

import { getPensByAgentId } from "lib/pdf";
import { saleIdRoundIdOnly } from "lib/sale";

import {
  getAuctionPensWithSaleLotsBySaleAndRound,
  currentSaleSelector,
  getOrganizationName,
  currentRoundSelector,
} from "selectors";

const mapStateToProps = (state, props) => ({
  auctionPens: props.match.params?.agentId
    ? getPensByAgentId(
        getAuctionPensWithSaleLotsBySaleAndRound(
          state,
          saleIdRoundIdOnly(props),
        ),
        props.match.params?.agentId,
      )
    : getAuctionPensWithSaleLotsBySaleAndRound(state, saleIdRoundIdOnly(props)),
  sale: currentSaleSelector(state),
  agencyName: getOrganizationName(state),
  round: currentRoundSelector(state, saleIdRoundIdOnly(props)),
});

const mapDispatchToProps = {};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(DeliveryCard);
